import { keyframes } from '@vanilla-extract/css';
import {
  makeMediaQuery,
  responsiveStyle,
} from '../responsive/responsive-style';
import { themeVars } from '../theme/vars';
import { borderRadius, boxShadows, space, zIndex } from '../tokens';
import { typography } from '../typography';
import { fadeIn, fadeOut } from '../animations.css';
import { style } from '../layer.css';

export const toastPrimitiveViewport = style({
  position: 'fixed',
  zIndex: zIndex.max,
  left: '50%',
  bottom: 0,
  transform: 'translateX(-50%)',
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'center',
  gap: `${space.s16}px`,
  margin: 0,
  padding: 0,
  listStyle: 'none',

  selectors: {
    ['&:not(:empty)']: {
      margin: `${space.s24}px 0`,
    },
  },

  ...responsiveStyle({
    mobile: {
      top: 0,
      bottom: 'auto',
      flexDirection: 'column',
      width: '100%',
    },
    tablet: {
      top: 'auto',
      bottom: 0,
      flexDirection: 'column-reverse',
      width: 'auto',
    },
  }),
});

const slideInFromBottom = keyframes({
  from: {
    transform: 'translateY(100%)',
  },
  to: {
    transform: 'translateY(0)',
  },
});
const slideInFromTop = keyframes({
  from: {
    transform: 'translateY(-100%)',
  },
  to: {
    transform: 'translateY(0)',
  },
});
const swipeOut = keyframes({
  from: {
    transform: 'translateX(var(--radix-toast-swipe-end-x))',
  },
  to: {
    transform: 'translateX(calc(150px + var(--radix-toast-swipe-end-x)))',
    opacity: 0,
  },
});

export const toastPrimitiveRoot = style({
  userSelect: 'auto !important' as 'auto',

  minHeight: '48px',
  padding: `${space.s12}px ${space.s24}px`,
  borderRadius: borderRadius.r8,
  backgroundColor: themeVars.button.primary.background.idle,
  color: themeVars.button.primary.foreground,
  boxShadow: boxShadows.default,

  willChange: 'transform, opacity',

  selectors: {
    ['&[data-swipe="move"]']: {
      transform: 'translateX(var(--radix-toast-swipe-move-x))',
    },

    ['&[data-swipe="cancel"]']: {
      transform: 'translateX(0)',
      transition: 'transform 200ms ease-out',
    },

    ['&[data-state="open"]']: {
      animation: `${fadeIn} 200ms ease-out`,
    },
    ['&[data-state="closed"]']: {
      animation: `${fadeOut} 200ms ease-out`,
    },
  },

  '@media': {
    '(prefers-reduced-motion: no-preference)': {
      selectors: {
        ['&[data-state="open"]']: {
          animation: `${slideInFromTop} 200ms ease-out`,
        },
        ['&[data-swipe="end"]']: {
          animation: `${swipeOut} 200ms ease-out`,
        },
      },
    },
    ...makeMediaQuery('md', {
      selectors: {
        ['&[data-state="open"]']: {
          animation: `${slideInFromBottom} 200ms ease-out`,
        },
      },
    }),
  },
});

export const toastPrimitiveTitle = style({
  ...typography['bodyMd'],
});

export const toastPrimitiveSubtitle = style({
  ...typography['bodySm'],
  wordBreak: 'break-word',
});

export const toastPrimitiveClose = style({
  margin: -9, // (size of icon button - size of icon) / 2
});
